import { TeamSearchCriteria } from "./TeamSearchCriteria";

export class TeamState {
    teamSearchCriteria: TeamSearchCriteria = new TeamSearchCriteria();
}